import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function IntercomIcon(props: IconProps) {
  const id = useId();
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <g clipPath={`url(#intercom-a-${id})`}>
        <path
          fill="#1F8DED"
          d="M17.333 10.996a.667.667 0 0 1-1.333 0V5a.667.667 0 0 1 1.333 0v5.996Zm-.232 4.173c-.103.088-2.573 2.16-7.101 2.16-4.528 0-6.998-2.072-7.1-2.16a.667.667 0 0 1 .866-1.014c.039.033 2.244 1.84 6.234 1.84 4.04 0 6.211-1.82 6.233-1.838a.667.667 0 0 1 .868 1.012ZM2.667 5A.667.667 0 0 1 4 5v5.996a.667.667 0 0 1-1.333 0V5ZM6 3.667a.667.667 0 0 1 1.333 0v8.906a.667.667 0 0 1-1.333 0V3.667Zm3.333-.338a.667.667 0 1 1 1.334 0v9.667a.667.667 0 0 1-1.334 0V3.329Zm3.334.338a.667.667 0 0 1 1.333 0v8.906a.667.667 0 0 1-1.333 0V3.667ZM17.5 0h-15A2.5 2.5 0 0 0 0 2.5v15A2.5 2.5 0 0 0 2.5 20h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 17.5 0Z"
        />
      </g>
      <defs>
        <clipPath id={`intercom-a-${id}`}>
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
